import { apiRequest } from './client.js';
import type { FeatureFlag, DevicePlatform } from '@hisob/types';

export interface CreateFeatureFlagPayload {
  key: string;
  enabled: boolean;
  platform?: DevicePlatform | 'all';
  minimum_app_version?: string | null;
  rollout_percentage: number;
  premium_only: boolean;
  config_json?: Record<string, unknown> | null;
}

export interface PatchFeatureFlagPayload {
  enabled?: boolean;
  platform?: DevicePlatform | 'all';
  minimum_app_version?: string | null;
  rollout_percentage?: number;
  premium_only?: boolean;
  config_json?: Record<string, unknown> | null;
}

export async function fetchFeatureFlags(): Promise<FeatureFlag[]> {
  const res = await apiRequest<{ items: FeatureFlag[] }>('/api/v1/admin/features');
  return res.items || [];
}

export async function createFeatureFlag(payload: CreateFeatureFlagPayload): Promise<FeatureFlag> {
  return apiRequest<FeatureFlag>('/api/v1/admin/features', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function patchFeatureFlag(
  key: string,
  payload: PatchFeatureFlagPayload
): Promise<FeatureFlag> {
  return apiRequest<FeatureFlag>(`/api/v1/admin/features/${key}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

